export enum AppSettings {
  DarkModeEnabled = 'DarkMode',
  LargeFontEnabled = 'LargeFont',
  LargeMenuEnabled = 'LargeMenu'
}
